export const ResponsesHeaderMixin = {
  data() {
    return {
      isSelectedAllFilters: {}
    };
  },
  computed: {
    sorting() {
      return this.$store.getters['responses/sorting'];
    },

    sortingIcon() {
      return {
        'sorting-down': this.sorting.order === 'desc',
        'sorting-up': this.sorting.order === 'asc'
      };
    },

    filter() {
      return this.$store.getters['responses/filter'];
    },

    selectedAll: {
      get() {
        if (!this.list.length) {
          return false;
        }
        return this.list.every(response => this.$store.getters['responses/isSelected'](response));
        // return this.$store.getters['responses/isSelectedAll']
      },

      set(val) {
        this.list.forEach(response =>
          this.$store.commit('responses/select', { model: response, value: val })
        );
        // this.$store.commit('responses/selectAll', val)
      }
    }
  },
  methods: {
    setSortingMethod(method) {
      if (this.isItSearch) {
        return;
      }

      const sorting = this.$store.getters['responses/sorting'];

      this.$store.dispatch('responses/updateSorting', {
        name: method,
        order: sorting.name !== method || sorting.order === 'desc' ? 'asc' : 'desc'
      });
    },

    set_show_filter(v) {
      this.$emit('set_show_filter', v);
    },

    // TODO: не используется метод, проверить
    fetchResponses() {
      this.$store.dispatch('responses/fetch');
      this.$store.dispatch('dictionary/fetchStagesAndStatuses');
    },

    // TODO: не используется метод, проверить
    set_filter_temp_selected_statuses(model) {
      this.$emit('set_filter_temp_selected_statuses', model.result);
      if (model.params && model.params.name) {
        this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
      }
    },

    set_filter_temp_dates(model) {
      this.$emit('set_filter_temp_dates', model.result);
    },

    set_filter_temp_dates_created(model) {
      this.$emit('set_filter_temp_dates_created', model.result);
    },

    set_filter_temp_selected_creators(model) {
      this.$emit('set_filter_temp_selected_creators', model.result);
      if (model.params && model.params.name) {
        this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
      }
    },

    set_filter_temp_selected_tags(model) {
      this.$emit('set_filter_temp_selected_tags', model.result);
      if (model.params && model.params.name) {
        this.isSelectedAllFilters[model.params.name] = !!model.params.isSelectAll;
      }
    },

    apply_filter(filter) {
      if (this.isSelectedAllFilters[filter] && this[`${filter}_clear`]) {
        this[`${filter}_clear`]();
        return;
      }
      this.$emit('apply_filter', filter);
    },

    cancel_filter() {
      this.$emit('cancel_filter');
    },

    // TODO: не используется метод, проверить
    status_clear() {
      this.$emit('status_clear');
    },

    date_clear(val) {
      this.$emit('date_clear', val);
    },

    creator_clear() {
      this.$emit('creator_clear');
    },

    tags_clear() {
      this.$emit('tags_clear');
    }
  }
};
